import * as React from 'react';
import {BlogPostsContext} from './BlogManagerContainer';
import BlogPostNewFACompResultForm from '../../components/blog/blogtemplates/BlogPostNewFACompResultForm';
export type BlogManagerProps = {
  children?: React.ReactNode;
};
const BlogManagerNewFACompResultPostContainer = ({
  children,
}: BlogManagerProps): JSX.Element => {
  const blogPostsContext = React.useContext(BlogPostsContext);
  return <BlogPostNewFACompResultForm />;
};

export default BlogManagerNewFACompResultPostContainer;
